<template>
  <div>
    <el-card
      v-for="(item, index) in options"
      :key="index"
      class="mb-2 pt-2"
      shadow="hover"
    >
      <div class="title-context">
        <div class="title">{{ item.v_title.text }}</div>
        <div class="subtext">
          <span class="mr-2">运单号：{{ item.v_title.waybillNo }}</span>
          <span v-if="item.v_title.recordType === 'T'"
            >箱号：{{ item.v_title.boxNo }}</span
          >
        </div>
      </div>
      <v-echarts
        :options="item"
        autoresize
        theme="light"
        style="width: 100%;"
      ></v-echarts>
    </el-card>
  </div>
</template>
<script>
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/toolbox'
export default {
  props: { data: { type: Array, default: () => [] } },
  data() {
    return { options: [] }
  },
  watch: {
    data: {
      handler(data) {
        this.analysisData(data)
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    analysisData(data) {
      this.options = []

      data.forEach((i) => {
        let legend = []
        let series = []
        i.series.forEach((j) => {
          legend.push(j.name)
          series.push({
            ...j,
            type: 'line',
            smooth: true,
            lineStyle: {
              color: '#5470C6',
              width: 4,
            },
            markPoint: {
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' },
              ],
            },
          })
        })
        const option = {
          v_title: {
            text: `设备编号: ${i.thermometerNo}`,
            // textStyle: {
            //   fontStyle: 'normal',
            //   fontSize: 14,
            // },
            waybillNo: i.waybillNo,
            boxNo: i.boxNo,
            recordType: i.recordType,
          },
          xAxis: {
            type: 'category',
            data: i.category,
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: '{value} °C',
            },
          },
          series,
          dataZoom: [
            {
              type: 'slider',
              show: true,
            },
          ],
          legend: {
            data: legend,
          },
          tooltip: {
            trigger: 'axis',
          },
          toolbox: {
            show: true,
            feature: {
              saveAsImage: { show: true },
            },
          },
        }
        this.options.push(option)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.title-context {
  text-align: center;
  margin-bottom: 10px;
  line-height: 30px;
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  .subtext {
    font-size: 14px;
    color: gray;
  }
}
</style>
